module.exports = __webpack_public_path__ + "img/swiper-item1-9.7a78187d.png";